import { format, parse, parseISO } from 'date-fns';
import { pick } from 'lodash-es';

import { BookAppointmentRequest } from '../../booking.types';
import { BOOKING_API_DATE_TIME_FORMAT, HOLD_API_DATE_TIME_FORMAT } from '../step-one/constants';
import { StepOneFormData } from '../step-one/schema';
import { StepTwoFormData } from '../step-two/schema';

function parsePhoneNumber(number: string) {
  return number.replace(/\((\d{3})\)(\d{3}-\d{4})/, '$1-$2');
}

function formatDate(input: string): string {
  const date = parseISO(input); // Parses "1977-12-12"
  return format(date, 'MM/dd/yyyy'); // Returns "12/12/1977"
}

// TODO: parentOrGuardian and address2 to be null
export const buildPayload = (
  stepsData: StepOneFormData &
    StepTwoFormData & {
      physicianNpi: string;
      holdId?: string;
      dateTimeOfAppointment?: string;
      date?: string;
      providerLocationId?: string;
      appointmentId?: string;
      siteType: string;
    }
): BookAppointmentRequest => {
  const formPatient = pick(stepsData, [
    'firstName',
    'lastName',
    'dateOfBirth',
    'gender',
    'email',
    'phoneNumber',
    'parentOrGuardian',
    // 'relationshipOfGuardian',
  ]) as BookAppointmentRequest['patient'];

  const reasonForReferral = stepsData.reasonForReferral
    ? `${stepsData.reasonForVisit}\n${stepsData.reasonForReferral}`
    : stepsData.reasonForVisit;

  const patient = {
    ...formPatient,
    dateOfBirth: formatDate(formPatient.dateOfBirth),
    phoneNumber: parsePhoneNumber(formPatient.phoneNumber),
    reasonForReferral: reasonForReferral || '',
    middleName: null,
    policyId: null,
    patientConfirmationPreference: null,
    secondaryInsuranceId: null,
    secondaryPolicyId: null,
    externalEncounterId: null,
    externalPatientId: null,
    insuranceId: null,
    parentOrGuardian: null,
  };

  const formAddress = pick(stepsData, [
    'address1',
    'address2',
    'city',
    'state',
    'zip',
  ]) as BookAppointmentRequest['address'];

  const address = {
    ...formAddress,
    address2: null,
    latitude: null, //  hardcoded like it is on legacy
    longitude: null, // hardcoded like it is on legacy
  };

  const dateTimeOfAppointment = stepsData.dateTimeOfAppointment || '';
  // dateTimeOfAppointment is in 2025122910:00 format so we generate UTC date from it
  const utcDateTimeOfAppointment = format(
    parse(dateTimeOfAppointment, HOLD_API_DATE_TIME_FORMAT, new Date()),
    BOOKING_API_DATE_TIME_FORMAT
  );

  //  TODO: Take all info
  return {
    appointmentId: stepsData.appointmentId || '', // get appointment id from hold ?
    appointmentTypeId: stepsData.appointmentType,
    // bookingType: null,
    dateTimeOfAppointment: utcDateTimeOfAppointment,
    holdId: stepsData.holdId || '',
    patient,
    // providerLocationId has to be calendarId
    providerLocationId: stepsData.providerLocationId || '', // get selected location from context
    caseID: null,
    referredByName: null,
    referredByPhone: null,
    source: 'dotcms', // this one is always dotcms :X
    bookingType: null,
    siteType: stepsData.siteType || 'Hospital+Operations',
    address,
    npi: stepsData.physicianNpi,
  };
};
